var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vote",class:{
        'vote-active': _vm.active,
        'vote-up': _vm.up,
        'vote-down': !_vm.up,
        'loader': _vm.loader
    },on:{"click":_vm.vote}})
}
var staticRenderFns = []

export { render, staticRenderFns }